import React, { useState } from 'react';
import './Header.css';
import { useCart } from '../../context/CartContext';

const Header = ({ setRoute }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { getCartItemCount, openCart } = useCart();
  const cartCount = getCartItemCount();

  const scrollToSection = (id) => {
    // Route-based navigation for specific pages
    if (id === 'contact' || id === 'products' || id === 'about' || id === 'privacy' || id === 'recipes') {
      if (typeof setRoute === 'function') {
        setRoute(id);
      } else {
        console.warn(`${id} route not available`);
      }
      setMobileMenuOpen(false);
      return;
    }

    // For home, navigate to home route first, then scroll
    if (typeof setRoute === 'function') setRoute('home');
    
    // Use setTimeout to ensure DOM is ready after route change
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
    
    setMobileMenuOpen(false);
  };

  const handleCartClick = () => {
    openCart();
    setMobileMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        <button 
          className="logo-link" 
          onClick={() => scrollToSection('home')}
          aria-label="Kajun Kitchen home"
        >
          <img src="/logo.png" alt="Kajun Kitchen Logo" className="logo" />
          <div className="logo-text">
            <span className="brand-name">Kajun Kitchen</span>
            <span className="brand-sub">Authentic Kajun Seasonings</span>
          </div>
        </button>

        {/* Desktop Navigation */}
        <nav className="nav-center" aria-label="Main navigation">
          <button onClick={() => scrollToSection('home')}>Home</button>
          <button onClick={() => scrollToSection('products')}>Products</button>
          <button onClick={() => scrollToSection('recipes')}>Recipes</button>
          <button onClick={() => scrollToSection('about')}>About</button>
          <button onClick={() => scrollToSection('contact')}>Contact</button>
          <button onClick={() => scrollToSection('privacy')}>Privacy</button>
        </nav>

        {/* Right side actions - Desktop Cart & Mobile Hamburger */}
        <div className="header-actions">
          {/* Desktop Cart Icon */}
          <button 
            className="cart-icon-desktop"
            onClick={handleCartClick}
            aria-label={`Shopping cart with ${cartCount} items`}
          >
            <i className="fas fa-shopping-cart"></i>
            {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
          </button>

          {/* Mobile Hamburger */}
          <button
            className="hamburger"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle mobile menu"
            aria-expanded={mobileMenuOpen}
          >
            <span className={mobileMenuOpen ? 'open' : ''}></span>
            <span className={mobileMenuOpen ? 'open' : ''}></span>
            <span className={mobileMenuOpen ? 'open' : ''}></span>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu">
          <div className="mobile-menu-header">
            <img src="/logo.png" alt="Kajun Kitchen Logo" className="mobile-menu-logo" />
            <div className="mobile-menu-brand">
              <span className="mobile-menu-brand-name">Kajun Kitchen</span>
              <span className="mobile-menu-brand-desc">Authentic Kajun Seasonings</span>
            </div>
          </div>
          <nav aria-label="Mobile navigation">
            <button onClick={() => scrollToSection('home')}>Home</button>
            <button onClick={() => scrollToSection('products')}>Products</button>
            <button onClick={() => scrollToSection('recipes')}>Recipes</button>
            <button onClick={() => scrollToSection('about')}>About</button>
            <button onClick={() => scrollToSection('contact')}>Contact</button>
            <button onClick={() => scrollToSection('privacy')}>Privacy</button>
            <button onClick={handleCartClick} className="cart-mobile-link">
              <i className="fas fa-shopping-cart"></i>
              Cart {cartCount > 0 && `(${cartCount})`}
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
